export const GET_CUSTOMERS_DATA_AND_LOADING = "GET_CUSTOMERS_DATA_AND_LOADING";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
export const GET_CUSTOMERS_LOADING = "GET_CUSTOMERS_LOADING";
export const GET_COMPANY_NAME = "GET_COMPANY_NAME";
export const GET_COMPANY_NAME_LOADING = "GET_COMPANY_NAME_LOADING";
